// extracted by mini-css-extract-plugin
export default {"root":"VerifiedBadge_root__O+a0J h6"};